// @ts-ignore
import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthRoute, OnboardedRoute, SessionRoute } from "@njoy/controller";

import { WelcomeScreen } from "../modules/welcome";
import { HomePage } from "../modules/home";
import { AddIdentityConnector } from "../modules/identity/add/AddIdentitiesConnector";
import { Finish } from "../modules/identity/add/ui/finish";

import { RegisterConnector } from "../modules/auth/register/RegisterConnector";
import { LoginConnector } from "../modules/auth/login/LoginConnector";
import { ForgotPasswordConnector } from "../modules/auth/forgotPassword/ForgotPasswordConnector";
import { ChangePasswordConnector } from "../modules/auth/changePassword/ChangePasswordConnector";
import { VerifyAccountPage } from "../modules/auth/verify/VerifyAccount";
import { ReverifyAccount } from "../modules/auth/verify/ReverifyAccount";

import { DiscoverHomeView } from "../modules/discover";
import { FindOfferCategoriesConnector } from "../modules/offers/find/FindOfferCategoriesConnector";
// import { TextPage } from "../modules/TextPage";

import { FinishSignupConnector } from "../modules/finishSignup/FinishSignupConnector";
import { ViewOfferConnector } from "../modules/offers/view/ViewOfferConnector";
import { MerchantChildOffers } from "../modules/offers/view/constants/MerchantChildOffers";
import { FindOffersConnector } from "../modules/offers/find/FindOffersConnector";
import { AlertsPage } from "../modules/alerts";
import { PointsOverviewPage } from "../modules/profile/pointsOverview";
import { ProfilePage } from "../modules/profile";
import { HelpPage } from "../modules/profile/help&Support";
import { AboutUsPage } from "../modules/profile/aboutUs";
import { LegalPage } from "../modules/profile/legal/legal";
import { PrivacyPolicyPage } from "../modules/profile/legal/privacyPolicy";
import { TermsAndConditionsPage } from "../modules/profile/legal/termsConditions";
import { AppSettingsPage } from "../modules/profile/appSettings";
import { TopUplimitPage } from "../modules/profile/topupLimit/index";
import { ConfirmTopUpLimitPage } from "../modules/profile/topupLimit/confirmTopUpLimit";
import { AccountDetailPage } from "../modules/profile/accountDetails/index";
import { ChangeEmailPage } from "../modules/profile/accountDetails/pages/email/changeEmail";
import { ChangeEmailOtpPage } from "../modules/profile/accountDetails/pages/email/changeEmailOtp";
import { PersonalDetailConnector } from "../modules/profile/personalDetails/PersonalDetailConnector";
import { ChangePhone } from "../modules/profile/accountDetails/pages/phone/changePhone";
import { ChangePhoneNumberOtpPage } from "../modules/profile/accountDetails/pages/phone/changePhoneOtp";
import { ChangePasswordPage } from "../modules/profile/accountDetails/pages/password/changePassword";
import { ChangePin } from "../modules/profile/accountDetails/pages/pin/changePin";
import { CloseAccount } from "../modules/profile/accountDetails/pages/close/closeAccount";
import { ManageIdCards } from "../modules/profile/manageIds/index";
import { PageAccountPendingDeletion } from "src/modules/accountPendingDeletion";

import { Logout } from "../modules/auth/logout";
import { PageError } from "../modules/pageError";

// import { WalletPage } from "../modules/wallet";
// import { InsightPage } from "../modules/wallet/insight";
import { SendMoneyPage } from "../modules/wallet/sendMoney";
import { SendInfoDetailsPage } from "../modules/wallet/sendInfoDetails";
import { SendMoneyDetailsPage } from "../modules/wallet/sendMoneyDetails";
// import { ViewTransactionDetailConnector } from "../modules/wallet/ViewTransactionDetailConnector";
import { ConfirmTransactionViewWallet } from "src/modules/wallet/confirmTransactionsWallet";

import ScrollToTop from "./scrollTop";
import * as ROUTES from "../constants/routes";
import { RedemptionHistoryPage } from "src/modules/profile/redemptionHistory";
import {RedemptionDetailsPage} from "src/modules/profile/redemptionHistory/redemptionDetails";
import { ReferralPage } from "src/modules/profile/referral";
import ViewBrandsPage from "src/modules/viewBrands";
import { CampaignWrapper } from "./CampaignWrapper";

export const AppRoutes = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route element={<AuthRoute />}>
        <Route element={<CampaignWrapper />}>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.CONNECT_ID} element={<AddIdentityConnector />} />
          <Route path={ROUTES.CONNECT_ID_SUCCESS} element={<Finish />} />
          <Route path={ROUTES.ALERTS} element={<AlertsPage />} />
           <Route path={ROUTES.POINTS_OVERVIEW} element={<PointsOverviewPage/>} />
          <Route path={ROUTES.MANAGE_ID_CARDS} element={<ManageIdCards />} />
          <Route path={ROUTES.REDEMPTION_HISTORY} element={<RedemptionHistoryPage/>}/>
          <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
          <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
          <Route path={ROUTES.HELP_AND_SUPPORT} element={<HelpPage/>} />
          <Route path={ROUTES.REFERRAL} element={<ReferralPage/>} />
          <Route path={ROUTES.LEGAL} element={<LegalPage />} />
          <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />

          <Route path={`${ROUTES.REDEMPTION_DETAILS}/:transactionId`} element={<RedemptionDetailsPage />} />
          <Route path={ROUTES.APP_SETTINGS} element={<AppSettingsPage />} />
          <Route path={ROUTES.TOP_UP_LIMIT} element={<TopUplimitPage />} />
          <Route path={ROUTES.CONFIRM_TOP_UP_LIMIT} element={<ConfirmTopUpLimitPage />} />
          <Route path={ROUTES.ACCOUNT_DETAILS} element={<AccountDetailPage />} />
          <Route path={ROUTES.CHANGE_EMAIL_DETAILS} element={<ChangeEmailPage />} />
          <Route path={ROUTES.CHANGE_EMAIL_OTP} element={<ChangeEmailOtpPage />} />
          <Route path={ROUTES.PERSONAL_DETAILS} element={<PersonalDetailConnector />} />
          <Route path={ROUTES.CHANGE_PHONE_NUMBER} element={<ChangePhone />} />
          <Route path={ROUTES.CHANGE_PHONE_NUMBER_DETAILS_OTP} element={<ChangePhoneNumberOtpPage />} />
          <Route path={ROUTES.CHANGE_PASSWORD_PROFILE} element={<ChangePasswordPage />} />
          <Route path={ROUTES.CHANGE_PIN} element={<ChangePin />} />
          <Route path={ROUTES.CLOSE_ACCOUNT} element={<CloseAccount />} />

          {/* wallet */}
          {/* temporary deactivation */}
          {/* <Route path={ROUTES.VIEW_WALLET} element={<WalletPage />} /> */}
          {/* <Route path={ROUTES.VIEW_INSIGHT} element={<InsightPage />} /> */}
          <Route path={ROUTES.VIEW_SEND_MONEY} element={<SendMoneyPage />} />
          <Route path={ROUTES.VIEW_SEND_INFO_DETAILS} element={<SendInfoDetailsPage />} />
          <Route path={ROUTES.VIEW_SEND_MONEY_DETAILS} element={<SendMoneyDetailsPage />} />
          <Route path={ROUTES.VIEW_WALLET_CONFIRM_TRANSACTION} element={<ConfirmTransactionViewWallet />} />
          {/* <Route path={ROUTES.VIEW_TRANSACTION_DETAIL} element={<ViewTransactionDetailConnector />} /> */}

          {/* Offers */}
          <Route path={ROUTES.DISCOVER} element={<DiscoverHomeView offset={0} limit={10} />} />
          <Route path={ROUTES.VIEW_ALL_MERCHANTS} element={<ViewBrandsPage />} />
          <Route path={ROUTES.FIND_OFFERS} element={<FindOffersConnector />} />
          <Route path={`${ROUTES.VIEW_OFFER}/:offerId`} element={<ViewOfferConnector />} />
          <Route path={`${ROUTES.VIEW_MERCHANT}/:userId`} element={<MerchantChildOffers />} />
          <Route path={`${ROUTES.FIND_CATEGORY}/:categoryId`} element={<FindOfferCategoriesConnector />} />
        </Route>
      </Route>

      <Route element={<OnboardedRoute />}>
        <Route path={ROUTES.FINISH_SIGNUP} element={<FinishSignupConnector />} />
      </Route>

      <Route element={<SessionRoute />}>
        <Route path={ROUTES.LANDING} element={<WelcomeScreen />} />
        <Route path={ROUTES.REGISTER} element={<RegisterConnector />} />
        <Route path={ROUTES.LOGIN} element={<LoginConnector />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordConnector />} />
        <Route path={ROUTES.CHANGE_PASSWORD} element={<ChangePasswordConnector />} />
        <Route path={ROUTES.VERIFY_ACCOUNT} element={<VerifyAccountPage />} />
        <Route path={ROUTES.ACCOUNT_PENDING_DELETION} element={<PageAccountPendingDeletion />} />
      </Route>

      <Route path="/resend-email" element={<ReverifyAccount />} />
      <Route path={ROUTES.TERMS_CONDITIONS} element={<TermsAndConditionsPage />} />

      <Route path={ROUTES.LOGOUT} element={<Logout />} />
      <Route path="*" element={<PageError />} />
    </Routes>
  </BrowserRouter>
);
